/* eslint-disable camelcase */
import common_es from './es/common.json';
import common_en from './en/common.json';

import errors_es from './es/errors.json';
import errors_en from './en/errors.json';

export default {
  en: {
    common: common_en,
    errors: errors_en,
  },
  es: {
    common: common_es,
    errors: errors_es,
  },
};
